module.exports = __webpack_public_path__ + "img/out.2b18eee1.png";